import { jsx as c, jsxs as g } from "react/jsx-runtime";
import { IressStack as w } from "../../../components/Stack/Stack.js";
import { useMemo as f, useId as y } from "react";
import { c as h } from "../../../index-2QXL0WYc.js";
import { l as m } from "../../../Loading.module-Bs6DSfb4.js";
import { IressText as M } from "../../../components/Text/Text.js";
import { IressPanel as S } from "../../../components/Panel/Panel.js";
import { IressProgress as j } from "../../../components/Progress/Progress.js";
import { GlobalCSSClass as L } from "../../../enums.js";
import { propagateTestid as O } from "../../../helpers/utility/propagateTestid.js";
import { useShowIndicator as C } from "../hooks/useShowIndicator.js";
import { useEstimatedProgressValue as G } from "../hooks/useEstimatedProgressValue.js";
const P = "ids-long-loading--root-v5150", V = "ids-long-loading--panel-v5150", B = "ids-long-loading--dots-v5150", E = "ids-long-loading--check-list-v5150", R = "ids-long-loading--check-list-item-v5150", T = "ids-long-loading--check-list-item__done-v5150", U = "ids-long-loading--checked-v5150", $ = "ids-long-loading--checked__circle-v5150", q = "ids-long-loading--checked__check-v5150", s = {
  root: P,
  panel: V,
  dots: B,
  checkList: E,
  checkListItem: R,
  checkListItem__done: T,
  checked: U,
  checked__circle: $,
  checked__check: q
}, z = () => {
  const t = y();
  return /* @__PURE__ */ g(
    "svg",
    {
      className: s.checked,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 52 52",
      "aria-labelledby": t,
      children: [
        /* @__PURE__ */ c("title", { id: t, children: "Finished: " }),
        /* @__PURE__ */ c(
          "circle",
          {
            className: s.checked__circle,
            cx: "26",
            cy: "26",
            r: "25",
            fill: "none"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            className: s.checked__check,
            fill: "none",
            d: "M14.1 27.2l7.1 7.2 16.7-16.8"
          }
        )
      ]
    }
  );
}, ce = ({
  children: t,
  className: v,
  error: k,
  estimatedFinishTime: r = 1e4,
  loaded: d,
  messageList: l = {},
  progress: N,
  renderProgress: u = (a) => /* @__PURE__ */ c(j, { ...a }),
  timeout: n,
  ...p
}) => {
  const a = C(
    d,
    n == null ? void 0 : n.message,
    (n == null ? void 0 : n.loaded) ?? 1300
  ), I = Math.max(...Object.keys(l).map(Number)) + 500, o = G(
    r,
    d,
    N,
    I
  ), _ = f(() => {
    const e = Object.keys(l), i = e.findIndex(
      (x) => Number(x) > o
    );
    return d ? "" : e[i] ?? e[e.length - 1];
  }, [l, d, o]), b = f(() => Object.entries(l).map(([e, i]) => ({
    timecode: Number(e),
    message: i,
    current: e === _,
    finished: o >= Number(e)
  })), [l, _, o]);
  return /* @__PURE__ */ c(
    "div",
    {
      className: h(s.root, v, m["fade-in"], {
        [m["fade-in--active"]]: a
      }),
      ...p,
      children: /* @__PURE__ */ c(
        S,
        {
          "data-testid": O(p["data-testid"], "panel"),
          className: h(s.panel, {
            [m.error]: !!k
          }),
          children: k ?? /* @__PURE__ */ g(w, { gutter: "md", children: [
            t,
            u({
              className: s.progress,
              min: 0,
              max: r,
              value: Math.min(o, r),
              sectionTitle: `${Math.min(o, r) / r * 100}% loaded`
            }),
            /* @__PURE__ */ c(M, { variant: "lead", noGutter: !0, children: /* @__PURE__ */ c("ul", { className: s.checkList, children: b.map((e) => /* @__PURE__ */ g(
              "li",
              {
                className: h(s.checkListItem, {
                  [s.checkListItem__done]: e.finished
                }),
                children: [
                  e.finished && /* @__PURE__ */ c(z, {}),
                  e.message,
                  e.current && /* @__PURE__ */ c("span", { className: s.dots, children: /* @__PURE__ */ c("span", { className: L.SROnly, children: "..." }) })
                ]
              },
              e.timecode
            )) }) })
          ] })
        }
      )
    }
  );
};
export {
  ce as LongLoading
};
